import { imageSize } from '../data/images'

type PageHeroProps = {
  index: string
  eyebrow?: string
  title: string
  description?: string
  image: string
  imagePosition?: string
}

export default function PageHero({ index, eyebrow, title, description, image, imagePosition }: PageHeroProps) {
  const titleScale = title.length > 38 ? 'long' : title.length > 27 ? 'medium' : 'short'

  return (
    <section className={`page-hero page-hero--title-${titleScale}`}>
      <div className="container page-hero__grid">
        <div className="page-hero__content">
          {eyebrow && <p className="eyebrow"><span>{index}</span>{eyebrow}</p>}
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
        <figure className="page-hero__media">
          <img
            src={`${import.meta.env.BASE_URL}images/${image}`}
            alt=""
            {...imageSize(image)}
            style={{ objectPosition: imagePosition }}
            fetchPriority="high"
          />
        </figure>
      </div>
    </section>
  )
}
